module.exports = __webpack_public_path__ + "static/img/topBorder.2d3a23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topBorder.png
// module id = b+Ow
// module chunks = 15